// Подписка компонента на канал ActionCable.
//
// Раньше каждая страница подписывалась вручную и сама хранила идентификатор
// обработчика:
//
//   const result = this.$store.dispatch('cable/subscribe', { ... })
//   this._handlerId = result ? result.handlerId : null
//
// Действие Vuex всегда возвращает Promise, поэтому `result.handlerId` был
// undefined, а проверка `!= null` в beforeDestroy не проходила — компонент
// не отписывался никогда. Обработчики копились: после трёх заходов на список
// автовозов одно сообщение канала запускало три перезагрузки, две из них —
// от уничтоженных компонентов, которые из-за живой ссылки не собирались
// сборщиком мусора.
//
// Теперь идентификатор выдаёт сам миксин — до вызова действия, — и он же
// снимает все подписки компонента при уничтожении.
//
// Использование:
//   import cableChannel from '@/mixins/cableChannel'
//   export default {
//     mixins: [cableChannel],
//     mounted () {
//       this.subscribeChannel({
//         channel: 'AutoCarriersChannel',
//         handlers: { received: () => this.initialize(true) }
//       })
//     }
//   }

let nextHandlerId = 1

export default {
  methods: {
    // subscribeChannel({ channel, params?, handlers? }) → handlerId
    subscribeChannel ({ channel, params = {}, handlers = {} }) {
      const handlerId = nextHandlerId++

      if (!this._cableSubscriptions) this._cableSubscriptions = []
      this._cableSubscriptions.push({ channel, params, handlerId })

      this.$store.dispatch('cable/subscribe', { channel, params, handlers, handlerId })

      return handlerId
    },

    // Снять подписку раньше уничтожения компонента (нужно редко).
    unsubscribeChannel (handlerId) {
      const subs = this._cableSubscriptions || []
      const idx = subs.findIndex(s => s.handlerId === handlerId)
      if (idx === -1) return

      this.$store.dispatch('cable/unsubscribeHandler', subs[idx])
      subs.splice(idx, 1)
    }
  },

  beforeDestroy () {
    ;(this._cableSubscriptions || []).forEach(sub => {
      this.$store.dispatch('cable/unsubscribeHandler', sub)
    })
    this._cableSubscriptions = null
  }
}
